"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCategoryMap = exports.getImportCopyrightMap = exports.getVideoPQLMap = exports.getVidyardTosMap = exports.getIsVideoPQLBannerDismissed = exports.getVidyardTosStatus = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var _Constants = require("../Constants");

var _PortalMetaCategoryIds = _interopRequireDefault(require("../enums/PortalMetaCategoryIds"));

var createCategoryValueGetter = function createCategoryValueGetter(defaultValue) {
  return function (categoryMap) {
    return categoryMap.get('category_value') || defaultValue;
  };
};

var getVidyardTosStatus = createCategoryValueGetter(_Constants.VidyardTosStatus.NOT_ASKED);
exports.getVidyardTosStatus = getVidyardTosStatus;
var getIsVideoPQLBannerDismissedValue = createCategoryValueGetter(false);

var getIsVideoPQLBannerDismissed = function getIsVideoPQLBannerDismissed(videoPqlMap) {
  return getIsVideoPQLBannerDismissedValue(videoPqlMap) === 'true';
};

exports.getIsVideoPQLBannerDismissed = getIsVideoPQLBannerDismissed;

var createCategoryMapGetter = function createCategoryMapGetter(portalDataCategory) {
  return function (portalDataList) {
    return portalDataList.find(function (portalDataMap) {
      return portalDataMap.get('category') === portalDataCategory;
    }) || _immutable.default.Map();
  };
};

var getVidyardTosMap = createCategoryMapGetter(_PortalMetaCategoryIds.default.VIDYARD_TOS_STATUS);
exports.getVidyardTosMap = getVidyardTosMap;
var getVideoPQLMap = createCategoryMapGetter(_PortalMetaCategoryIds.default.DISMISS_VIDEO_PQL_V1);
exports.getVideoPQLMap = getVideoPQLMap;
var getImportCopyrightMap = createCategoryMapGetter(_PortalMetaCategoryIds.default.IMPORT_IMAGE_COPYRIGHT_NOTICE);
exports.getImportCopyrightMap = getImportCopyrightMap;

var getCategoryMap = function getCategoryMap(portalMetaList, categoryId) {
  return portalMetaList.find(function (item) {
    return item.get('category') === categoryId;
  });
};

exports.getCategoryMap = getCategoryMap;